export default __webpack_public_path__ + "static/media/price-range.70844910.svg";